<template>
  <scoped v-if="value">
    <Enumeration
      v-model:selection="value.type"
      title="Type"
      :options="['DOCUMENT', 'PICTURE', 'VIDEO']"
      :readOnly="readOnly"
    />
    <template v-if="value.type == 'DOCUMENT'">
      <DocumentMedia
        :data="value.data"
        :extension="value.extension"
        :title="value.name"
        :url="value.url"
      />
    </template>
    <template v-if="value.type == 'PICTURE'">
      <ImageMedia
        :data="value.data"
        :extension="value.extension"
        :title="value.name"
        :url="value.url"
      />
    </template>
    <template v-if="value.type == 'VIDEO'">
      <VideoMedia
        :data="value.data"
        :extension="value.extension"
        :title="value.name"
        :url="value.url"
      />
    </template>
    <TextInput
      v-model:value="value.name"
      title="Name"
      :readOnly="readOnly"
    />
    <TextInput
      v-model:value="value.extension"
      readOnly
      title="Extension"
    />
    <TextInput
      v-model:value="value.description"
      title="Description"
      :readOnly="readOnly"
      multiline
    />
    <FileInput
      v-if="!readOnly"
      ref="fileInput"
      title="Change File"
      @update="update()"
    />
  </scoped>
</template>

<script setup lang="ts">
  import DocumentMedia from "@/components/media/document.vue"
  import ImageMedia from "@/components/media/image.vue"
  import VideoMedia from "@/components/media/video.vue"
  import Enumeration from "@/components/selectors/enumeration.vue"
  import TextInput from "@/components/inputs/text.vue"
  import FileInput from "@/components/inputs/file.vue"
  import {PropType, useTemplateRef} from "vue"
  import {File} from "@/endpoints/rutsolve/gql/generated/graphql"

  defineProps({
    readOnly: {
      default: false,
      required: false,
      type: Boolean
    }
  })

  const value = defineModel("value", {
    default: null,
    required: true,
    type: Object as PropType<File>
  })

  const fileInput = useTemplateRef("fileInput")

  function update() {
    value.value.data = fileInput.value.files[0].data
    value.value.extension = fileInput.value.files[0].extension
    value.value.name = fileInput.value.files[0].name
    value.value.url = null
  }
</script>

<style scoped>
  .column {
    display: inline-block;
    margin: 0 1em 1em 0;
    vertical-align: top;

    &:last-child {
      margin-right: 0;
    }
  }
</style>
